import { Slider as AntdSlider } from "antd";
import React from "react";
export interface SliderProps {
  /** Label for the slider, used for accessibility */
  label: string;
  /** Minimum value of the slider */
  min?: number;
  /** Maximum value of the slider */
  max?: number;
  /** Step value for increments */
  step?: number;
  /** Controlled value of the slider */
  value?: number;
  /** Callback when the value changes */
  onChange?: (value: number) => void;
  /** Whether the slider is disabled */
  disabled?: boolean;
  /** Marks on the slider track */
  marks?: Record<number, string>;
  /** Tooltip visibility on the slider handle */
  tooltipVisible?: boolean;
  /** Description or additional info for the slider */
  description?: string;
}
const Slider: React.FC<SliderProps> = ({
  label,
  min = 0,
  max = 100,
  step = 1,
  value,
  onChange,
  disabled = false,
  marks,
  tooltipVisible = true,
  description,
}) => {
  const id = `slider-${label.toLowerCase().replace(/\s+/g, "-")}`;
  return (
    <div>
      <label 
      htmlFor={id} style={{ display: "block", marginBottom: "8px" }}>
        {label}
      </label>
      {description && (
        <p
          id={`${id}-description`}
          style={{ fontSize: "12px", marginBottom: "8px", color: "#6c757d" }}
        >
          {description}
        </p>
      )}
      <AntdSlider
        id={id}
        aria-labelledby={id}
        aria-describedby={description ? `${id}-description` : undefined}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
        disabled={disabled}
        marks={marks}
        tooltip={{ open: tooltipVisible }}
      />
    </div>
  );
};
export default Slider;
